import React, { useEffect, useState } from "react";
import { Button, Col, Container, Row, Spinner, Stack, Table } from "react-bootstrap";
import { DatatableWrapper, Filter, Pagination, PaginationOptions, TableBody, TableHeader } from "react-bs-datatable";

import { Link, useNavigate } from "react-router-dom";
import { isMobile, BrowserView } from "react-device-detect";

import trasportApi from "../../api/trasportApi";
import ".././../assets/css/ListComponentsTable.css"
import { ROUTES } from "../../constants/WebRouting";
import { formatDate, getUserDetails } from "../../utils/helper";
// import { CSVUpload } from "../../utils/CSVUpload";
import InfoPill from "../InfoPill";
import Main from "../layout/Main";

const PurchaseOrderList = () => {
  const navigate = useNavigate();
  const [body, setBody] = useState();
  // const [contacts, setContacts] = useState();
  async function init() {
    const result = await trasportApi.fetchPurchaseOrders();

    if (result) {
      setBody(result);
      // setContacts(result);
    } else {
      setBody([]);
      // setContacts([]);
    }
  }
  useEffect(() => {
    init();
  }, []);

  // Create table headers consisting of 4 columns.
  // Randomize data of the table columns.
  // Note that the fields are all using the `prop` field of the headers.
  const header = [];
  if (!isMobile) {
    header.push(
      {
        title: "Purchase Order Number", prop: "purchase_order_no", isFilterable: true, isSortable: false, cell: (row) => (
          <Link to={`${ROUTES.PURCHASE_ORDER.LIST}/${row.id}`} state={row}>
            {row.purchase_order_no}
          </Link>
        ),
      },
      {
        title: "Supplier", prop: "contact_name", isFilterable: true, filterKey: "contact_name", cell: (row) => (<Link to={`${ROUTES.CONTACT.LIST}/${row.contact_id}`} state={{ id: row.contact_id }}>
          {row.contact_name}
        </Link>
        ),
      },
      // {
      //   title: "Supplier", prop: "contact_id", isFilterable: true, isSortable: false, cell: (row) => (<Link to={`${ROUTES.CONTACT.LIST}/${row.contact_id}`} state={row}>
      //     {row.contact_name}
      //   </Link>
      //   ),
      // },
      { title: "Purchase Date", prop: "purchase_date", isFilterable: true, isSortable: false, cell: (row) => (formatDate(row.purchase_date)) },
      // { title: "PI Number ", prop: "pi_no", isFilterable: true },
      { title: "Payment Status", prop: "payment_status", isFilterable: true },
      { title: "Origin", prop: "origin", isFilterable: true },
      { title: "Purchase Price", prop: "purchase_price", isFilterable: true }
    );
  } else {
    //for mobile device
    header.push({
      title: "Info",
      prop: "name",
      isFilterable: true,
      isSortable: true,
      cell: (row) => (
        <div className="mobilecard">
          <Link
            to={`${ROUTES.PURCHASE_ORDER.LIST}/${row.id}`}
            state={row}
            style={{ width: "100%" }}
          >
            {row.firstname} {row.lastname}
          </Link>

          <span>
            <i className="fa-solid fa-phone"></i> {row.phone}
          </span>
          <span style={{ width: "80%" }}>
            <i className="fa-solid fa-envelope"></i> {row.email}
          </span>
        </div>
      ),
    });
  }

  const labels = {
    beforeSelect: " ",
  };

  const create = () => {
    navigate(ROUTES.PURCHASE_ORDER.CREATE);
  };

  return (

    // <Main>
    <>
      <Main>

      <Container fluid>
        <DatatableWrapper
          body={(body && Array.isArray(body)) ? body : []}
          headers={header}
          paginationOptionsProps={{
            initialState: {
              rowsPerPage: 10,
              options: [5, 10, 15, 20],
            },
          }}
        >
          <Row className="align-items-end">
            <Col
              xs={12}
              lg={4}
              className="d-flex flex-col justify-content-end align-items-end"
            >
              <Filter classes={{ inputGroup: "", input: "", clearButton: "btn-custom" }} />
            </Col>
            <Col
              xs={12}
              sm={6}
              lg={5}
              className="d-flex flex-col justify-content-start align-items-center"
            // md={1} 
            >
              <PaginationOptions labels={labels} md={1} />
              <BrowserView className="mx-5 mt-4">
                <InfoPill left="Total" right={body?.length} />
              </BrowserView>
            </Col>
            <Col
              xs={12}
              sm={6}
              lg={3}
              className="d-flex flex-col justify-content-end align-items-end"
            >
              <Stack direction="horizontal" gap={2}>
                <Button
                  size="sm"
                  className="btn-create"
                  onClick={() => create(true)}
                >
                  New Purchase Order
                </Button>
              </Stack>
            </Col>
          </Row>

          <Table striped className="shadow rounded sm my-4 data-table" responsive={true}>
            <TableHeader classes={{  }} />
            {
              (body && Array.isArray(body)) ?
                <TableBody />
                :   
                <tbody className="">
                  <tr>
                    <td colSpan={100} align="center">
                      <div>
                        <Spinner />
                      </div>
                    </td>
                  </tr>
                </tbody>
            }
          </Table>
          <Pagination classes={{ buttonGroup: "", button: "bg-custom border-white" }} />
        </DatatableWrapper>
      </Container>
      </Main>
    </>

  );
};

export default PurchaseOrderList;
